module.exports = __webpack_public_path__ + "01ea978f/img/rename-icon.de4e673d.svg";